import {
  Button,
  Grid,
  Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ListFilter } from "lucide-react";
import {
  useState
} from "react";
import { useTranslation } from "react-i18next";
import {
  StyledFilterBox
} from "./Filters.styles";
import type { FiltersProps } from "./Filters.types";
import { useAnnouncement } from "../../components/Announcement/Announcement.component";
import { Select } from "../Select/Select.component";

/**
 * this component expects filter and setFilter to be set as state of the parent,
 * where an unfiltered case is represented by the empty string
 * @param param0
 * @returns
 */
export function Filters<T extends string>({
  filter,
  options,
  setFilter
}: FiltersProps<T>) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const { t } = useTranslation();
  const { announce } = useAnnouncement();


  return (
    <StyledFilterBox>
      <Grid
        className={ `${(filter && filter.length > 0 ) || open ? "filters selected" : " filters" }` }
        alignItems={ "center" }
        display={ "flex" }
        flexDirection={ "column" }
        position={ "relative" }
        sx={ {
          ".MuiFormControl-root ":{
            position:"absolute",
            top:"-1.875rem"
          },
          [theme.breakpoints.down("sm")]:{
            marginRight:"12px"
          }
        } }
      >
        <Button
          variant="text"
          type="button"
          aria-label={ t("filter") }
          aria-haspopup="listbox"
          aria-expanded={ open }
          onClick={ () => setOpen(!open) }
          sx={ {
            "&:focus-visible": {
              outline: `2px solid ${theme.customColors.borderPrimaryCta}`,
              outlineOffset: "2px"
            }
          } }
          className="filter-button"
        >
          <ListFilter
            size={ 24 }
            stroke={ open ? theme.customColors.backgroundPrimaryCta : theme.customColors.exploreCardText }
            color={ open ? theme.customColors.backgroundPrimaryCta : theme.customColors.exploreCardText }
            aria-hidden="true"
          />
        </Button>
        <Select
          options={ options }
          id={ t("filter") || undefined }
          multiple
          open={ open }
          onClose={ () => setOpen(false) }
          onOpen={ () => setOpen(true) }
          onChange={ (changeEvent) => {
            if (!setFilter) return;
            setFilter((prev:[T]|[]) => {
              const newValue = changeEvent.target.value as [T]|[];
              if(prev.length > newValue.length){
                announce(t("filter_communty_removed"));
              }else if(prev.length < newValue.length ){
                announce(t("filter_communty_applied"));
              }
              setOpen(!open);
              return newValue;
            });
          } }
          value={ filter }
        />
        <Typography
          color={ theme.customColors.exploreCardText }
          sx={ {
            [theme.breakpoints.down("sm")]:{
              fontSize: "0.75rem"
            }
          } }
        >
          { t("filter") }
        </Typography>
      </Grid>

    </StyledFilterBox>
  );
}
